import PropTypes from 'prop-types';
import { useState } from 'react';

// material-ui
import { Collapse, List, ListItemButton, ListItemIcon, ListItemText, Typography } from '@mui/material';

// project imports
import NavItem from '../NavItem';

// assets
import { IconChevronDown, IconChevronUp } from '@tabler/icons';
import Icon from "../../../../components/icons"


const NavCollapse = ({ menu, level }) => {
    const [open, setOpen] = useState(false);
    const [selected, setSelected] = useState(null);

    const handleClick = () => {
        setOpen(!open);
        setSelected(!selected ? menu.id : null);
    };

    // menu collapse & item
    const menus = menu.children?.map((item) => {
        switch (item.type) {
            case 'collapse':
                return <NavCollapse key={item.id} menu={item} level={level + 1} />;
            case 'item':
                return <NavItem key={item.id} item={item} level={level + 1} />;
            default:
                return (
                    <Typography key={item.id} variant="h6" color="error" align="center">
                    Menu Items Error
                    </Typography>
                );
        }
    });

    const menuIcon = () => {
      switch(menu.id) {
        case 'Erlich':
            return <Icon.Bike width="33" height="33" style={{ marginTop: 'auto', marginBottom: 'auto' }} />;

        case 'Tiger':
            return <Icon.Tiger width="28" height="28" style={{ marginTop: 'auto', marginBottom: 'auto' }} />;

        case 'Users':
            return <Icon.Users width="25" height="25" style={{ marginTop: 'auto', marginBottom: 'auto' }} />;

        case 'Self_Diagnostic':
            return <Icon.Stethoscope width="25" height="25" style={{ marginTop: 'auto', marginBottom: 'auto' }} />;

        case 'Passerine':
            return <Icon.Passerine width="25" height="25" style={{ marginTop: 'auto', marginBottom: 'auto' }} />;

         case 'Automation':
            return <Icon.Automation width="25" height="25" style={{ marginTop: 'auto', marginBottom: 'auto' }} />;

         case 'Nestling':
            return <Icon.Nestling width="25" height="25" style={{ marginTop: 'auto', marginBottom: 'auto' }} />;

         case 'Automation_ad':
            return <Icon.Automation width="25" height="25" style={{ marginTop: 'auto', marginBottom: 'auto' }} />;

         case 'Automation_adv':
            return
        default:
            return <Icon.Tiger width="28" height="28" style={{ marginTop: 'auto', marginBottom: 'auto' }} />;
      }
    }

    return (
        <>
            <ListItemButton
                sx={{
                    mb: 0.5,
                    alignItems: 'flex-start',
                    borderRadius: 3,
                    backgroundColor: level > 1 ? 'transparent !important' : 'inherit',
                    pl: `${level * 10}px`,
                    "&:hover": {
                      borderRadius: 3,
                      backgroundColor: "#E3F2FD",
                      color: "#406599",
                      "& .MuiListItemIcon-root": {
                        color: "#406599"
                      }
                    }
                }}
                selected={selected === menu.id}
                onClick={handleClick}
            >
                <ListItemIcon sx={{ my: 'auto', minWidth: !menu.icon ? 18 : 36 }}>{menuIcon()}</ListItemIcon>
                <ListItemText
                    primary={
                        <Typography sx={{fontFamily: '"Roboto", "sans-serif"'}}>
                            {menu.title}
                        </Typography>
                    }
                />
                {open ? (
                    <IconChevronUp stroke={1.5} size="1rem" style={{ marginTop: 'auto', marginBottom: 'auto' }} />
                ) : (
                    <IconChevronDown stroke={1.5} size="1rem" style={{ marginTop: 'auto', marginBottom: 'auto' }} />
                )}
            </ListItemButton>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List
                    component="div"
                    disablePadding
                    sx={{
                        position: 'relative',
                        '&:after': {
                            content: "''",
                            position: 'absolute',
                            left: '32px',
                            top: 0,
                            height: '100%',
                            width: '1px',
                            opacity: 1,
                            background: '#60ABD2'
                        }
                    }}
                >
                    {menus}
                </List>
            </Collapse>
        </>
    );
};

NavCollapse.propTypes = {
    menu: PropTypes.object,
    level: PropTypes.number
};

export default NavCollapse;
